import React, { useEffect } from 'react';
import { change, getFormValues } from 'redux-form';
import { TextareaAutosize } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { Select } from '@material-ui/core';
import { connect, useDispatch, useSelector } from 'react-redux';
import useStyles from '../styles/styles';
import { formName } from '../thunks/constants';

const PeNotes = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const state = useSelector((state) => ({
        shell: state.shell,
    }));

    const [note, setNote] = React.useState('');
    const [editText, setEditText] = React.useState(props.formValues?.pe_note);

    const handleSelect = event => {
        setNote(event.target.value);
    };

    const handleChange = event => {
        setEditText(event.target.value);
    };

    const renderOption = () => {
        let options = state.shell?.templates?.notes;
        let keyArr = [];
        // push key to arr
        if (options) for (var key in options) {
            if (options.hasOwnProperty(key)) {
                keyArr.push(options[key]);
            }
        }
        // render option
        return keyArr.map((item, index)=>{
            return <option key={index} value={item.content}>{item.title}</option>
        });
    }

    useEffect(() => {
        setEditText(note);
        return () => {
            setEditText(note);
        };
    }, [note]);

    useEffect(() => {
        dispatch(change(formName, 'pe_note', editText));
    }, [dispatch, editText]);

    return (
      <div className={classes.control}>
        <FormControl variant="outlined" fullWidth>
          <h3 className={classes.label}>PE Note:</h3>
          <Select native
              id="note_select"
              name="note_select"
              value={note}
              onChange={handleSelect}>
              <option value="">Select note...</option>
              {renderOption()}
          </Select>
          <br />
          <TextareaAutosize
              id={'pe_note'}
              name={'pe_note'}
              className={classes.textArea}
              onChange={handleChange}
              value={editText}
              style={{
                  fontSize: '14px',
                  fontWeight: 400,
                  padding: '10px',
              }}
              placeholder={'Notes'}
          />
        </FormControl>
      </div>
    );
};

export default connect(state => ({
    formValues: getFormValues(formName)(state)
}))(PeNotes);